'use strict';
var Component = require('./Component');
var _ = require('underscore');
var util = require('../../helper/util');
var logHelper = require('../../helper/logHelper');


/*所有功能组件集合*/
var Components = {
  '__group__': require('./Group.jsx'),

  'Alert': require('./Alert'),
  'AlertWindow': require('./AlertWindow'),

  'Button': require('./Button.jsx'),

  'CheckBox': require('./Checkbox.jsx'),
  'CheckBoxGroup': require('./CheckboxGroup.jsx'),

  'CompositeComboBox': require('./CompositeComboBox.jsx'),
  'ComboBox': require('./ComboBox.jsx'),
  'CircleProgressBar': require('./CircleProgressBar.jsx'),
  'ContentPanel': require('./ContentPanel.jsx'),
  'Canvas': require('./Canvas.jsx'),

  'Graffiti': require('./Graffiti.jsx'),
  'GroupBox': require('./GroupBox.jsx'),

  'HotSpot': require('./HotSpot.jsx'),

  'Image': require('./Image.jsx'),
  'ImageBackground': require('./ImageBackground.jsx'),
  'ImageCarousel': require('./ImageCarousel.jsx'),

  'Label': require('./Label.jsx'),
  'Link': require('./Link.jsx'),
  'Line': require('./Line.jsx'),
  'Arrow': require('./Line.jsx'),
  'List': require('./List.jsx'),
  'LabelTextInput': require('./LabelTextInput.jsx'),
  'LinkBar': require('./LinkBar.jsx'),

  'ModalScreen': require('./ModalScreen.jsx'),

  'Panel': require('./Panel.jsx'),
  'ProgressBar': require('./ProgressBar.jsx'),

  'RadioButton': require('./RadioButton.jsx'),
  'RadioButtonGroup': require('./RadioButtonGroup.jsx'),

  'Shape': require('./Shape.jsx'),
  'ScrollView': require('./ScrollView.jsx'),
  'ScrollArea': require('./ScrollArea.jsx'),
  'ScopeBar': require('./ScopeBar.jsx'),
  'SlidingDrawer': require('./SlidingDrawer.jsx'),

  'TextArea': require('./TextArea.jsx'),
  'TextInput': require('./TextInput.jsx'),
  'TitleWindow': require('./TitleWindow.jsx'),

  'PopupPanel': require('./PopupPanel.jsx'),
  'PopupPanelContent': require('./PopupPanelContent.jsx'),
  'PopupMenu': require('./PopupMenu.jsx'),

  'SwitchIOS': require('./SwitchIOS.jsx'),
  'Switch': require('./Switch.jsx'),
  'PointyButton': require('./PointyButton.jsx'),
  'Tree': require('./TreeEx.jsx'),

  'LineChart': require('./LineChart.jsx'),
  'LineChartEx': require('./LineChartEx.jsx'),
  'Icon': require('./Icon.jsx'),

  'Accordion': require('./Accordion'),
  //'DataGrid': require('./DataGrid'),
  'DataGrid': require('./Table'),

  'VerticalTabBar': require('./VerticalTabBar'),
  'Tab': require('./HorizontalTabBar'),

  'VerticalScrollbar': require('./VerticalScrollBarCom'),
  'HorizontalScrollBar': require('./HorizontalScrollBarCom'),
  'Slider': require('./Slider'),
  'TableView': require('./TableView'),
  'StatusBar(IOS)': require('./IOSStatusBar'),
  'VRule': require('./VRule'),

  'HRule': require('./HorizontalRule'),
  'VSplitter': require('./VerticalSplitter'),
  'HSplitter': require('./HorizontalSplitter'),
  'PageControl': require('./PageControl'),
  'PageControlEx': require('./PageControlEx'),
  'BrowserWindow': require('./BrowserWindow'),
  'IPhone': require('./IPhone'),
  'Phone': require('./AndroidPhone'),
  'IPad': require('./IPad'),
  'TabletPC': require('./TabletPC'),

  'IPhone2': require('./NewPhone'),
  'Android': require('./NewPhone'),
  'IPad2': require('./NewPhone'),
  'TabletPC2': require('./NewPhone'),
  'Tabs': require('./Tabs'),
  'ButtonBar': require('./ButtonBar'),
  'Menu': require('./Menu'),
  'MenuBar': require('./MenuBar'),
  'NumericStepper': require('./NumericStepper'),
  'DateTimePicker': require('./DateTimePicker'),
  'ColorPicker': require('./ColorPicker'),
  'HSlider': require('./HSlider2'),
  'VSlider': require('./VSlider2'),
  'HSlider2': require('./HSlider2'),
  'VSlider2': require('./VSlider2'),
  'Search': require('./SearchBox'),
  'BreadCrumbs': require('./BreadCrumbs'),
  'ToolTip': require('./ToolTip'),
  'StickyNote': require('./StickyNote'),
  'CallOut': require('./CallOut'),
  'HCurly': require('./HCurly'),
  'VCurly': require('./VCurly'),
  'RedX': require('./RedX'),
  'ScratchOut': require('./ScratchOut'),
  'QRCode': require('./QRCode'),
  'Calendar': require('./Calendar'),
  'Webcam': require('./Webcam'),
  'AvatarEx': require('./AvatarEx'),
  'ColumnChart': require('./ColumnChart'),
  'ColumnChartEx': require('./ColumnChartEx'),
  'BarChart': require('./BarChart'),
  'BarChartEx': require('./BarChartEx'),
  'Form': require('./Form'),

  'TextField': require('./TextField'),
  'Spinner': require('./Spinner'),
  'AlarmIcon': require('./AlarmIcon'),
  'StatusBar(Android)': require('./AndroidStatusBar'),
  'NavigationBar': require('./NavigationBar'),
  'Keyboard': require('./Keyboard'),

  'VolumeSlider': require('./VolumeSlider'),
  'VideoPlayer': require('./VideoPlayer'),
  'Media_Control': require('./Media_Control'),
  'PieChart': require('./PieChart'),
  'PieChartEx': require('./PieChartEx'),
  'Map': require('./Map'),
  'CoverFlow': require('./CoverFlow'),
  'EditToolbar': require('./EditToolbar'),
  'FormattingToolbar': require('./FormattingToolbar'),
  'HelpButton': require('./HelpButton'),
  'QuickContact': require('./QuickContact'),
  'Avatar(Mobile)': require('./AvatarMobile'),
  'LetterNavigation': require('./LetterNavigation'),
  'TimePicker': require('./TimePicker'),
  'TimePicker2': require('./TimePicker2'),
  'IconButton': require('./IconButton'),
  'IconLabel': require('./IconLabel'),
  'Top ActionBar': require('./TopActionBar'),
  'Contexual ActionBar': require('./ContextActionBar'),
  'Control PopOver': require('./ControlPopOver'),
  'SiteMap': require('./SiteMap'),
  'Subtitle': require('./Label'),
  'BigTitle': require('./Label'),
  'IconButton2': require('./IconButton2'),
  'IconLabel2': require('./IconLabel2'),
  'AlarmIcon2': require('./AlarmIcon2'),
  'IconButtonCommon': require('./IconButtonCommon'),
  'IconBar': require('./IconBar')
};

/*视图类型*/
function isInvisualInteractiveCom(controlTypeID) {
  var isInvisualCom = false;
  var typeID = controlTypeID;
  if (typeID === 'PopupPanel' || typeID === 'HoverPanel' || typeID === 'AlertWindow' || typeID === 'PopupMenu' || typeID === 'SlidingDrawer') {
    isInvisualCom = true;
  }
  return isInvisualCom;
}

/*链接类型*/
var LinkAreaLayout = {
  NONE: 'none',
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
  CLIENT: 'client',
  V_AVG: 'v_avg',
  H_AVG: 'h_avg',
  CUSTOM: 'custom'
};

/*组件布局类型绑定*/
var LinkFitMode = {
  Button: LinkAreaLayout.CLIENT,
  Label: LinkAreaLayout.CLIENT,
  TextArea: LinkAreaLayout.CLIENT,
  Shape: LinkAreaLayout.CLIENT,
  Icon: LinkAreaLayout.CLIENT,
  Image: LinkAreaLayout.CLIENT,
  TextInput: LinkAreaLayout.CLIENT,
  Line: LinkAreaLayout.CLIENT,
  HotSpot: LinkAreaLayout.CLIENT,
  HRule: LinkAreaLayout.CLIENT,
  VRule: LinkAreaLayout.CLIENT,
  CheckBox: LinkAreaLayout.CLIENT,
  CheckBoxGroup: LinkAreaLayout.NONE,
  LabelTextInput: LinkAreaLayout.CLIENT,
  RadioButton: LinkAreaLayout.CLIENT,
  RadioButtonGroup: LinkAreaLayout.NONE,
  CompositeComboBox: LinkAreaLayout.CLIENT,
  List: LinkAreaLayout.HORIZONTAL,
  ButtonBar: LinkAreaLayout.H_AVG,
  Menu: LinkAreaLayout.HORIZONTAL,
  MenuBar: LinkAreaLayout.NONE,
  ToolTip: LinkAreaLayout.CLIENT,
  NumericStepper: LinkAreaLayout.CLIENT,
  DateTimePicker: LinkAreaLayout.CLIENT,
  ColorPicker: LinkAreaLayout.CLIENT,
  IconButton: LinkAreaLayout.CLIENT,
  IconButton2: LinkAreaLayout.CLIENT,
  IconLabel: LinkAreaLayout.CLIENT,
  IconLabel2: LinkAreaLayout.CLIENT,
  VSlider: LinkAreaLayout.CLIENT,
  HSlider: LinkAreaLayout.CLIENT,
  VSlider2: LinkAreaLayout.CLIENT,
  HSlider2: LinkAreaLayout.CLIENT,
  ModalScreen: LinkAreaLayout.CLIENT,
  ProgressBar: LinkAreaLayout.CLIENT,
  CircleProgressBar: LinkAreaLayout.CLIENT,
  Search: LinkAreaLayout.CLIENT,
  Alert: LinkAreaLayout.NONE,
  LinkBar: LinkAreaLayout.H_AVG,
  BreadCrumbs: LinkAreaLayout.NONE,
  Tree: LinkAreaLayout.HORIZONTAL,

  SiteMap: LinkAreaLayout.NONE,
  DataGrid: LinkAreaLayout.HORIZONTAL,
  VSplitter: LinkAreaLayout.CLIENT,
  HSplitter: LinkAreaLayout.CLIENT,
  GroupBox: LinkAreaLayout.CLIENT,
  __group__: LinkAreaLayout.CLIENT,
  VerticalScrollbar: LinkAreaLayout.CLIENT,
  HorizontalScrollBar: LinkAreaLayout.CLIENT,
  PageControl: LinkAreaLayout.NONE,
  VerticalTabBar: LinkAreaLayout.NONE,
  Tab: LinkAreaLayout.NONE,
  Accordion: LinkAreaLayout.HORIZONTAL,
  TitleWindow: LinkAreaLayout.CLIENT,
  BrowserWindow: LinkAreaLayout.CLIENT,
  IPhone: LinkAreaLayout.CLIENT,
  IPad: LinkAreaLayout.CLIENT,
  Phone: LinkAreaLayout.CLIENT,
  TabletPC: LinkAreaLayout.CLIENT,
  Iphone: LinkAreaLayout.CLIENT,
  Android: LinkAreaLayout.CLIENT,
  Ipad2: LinkAreaLayout.CLIENT,
  TabletPC2: LinkAreaLayout.CLIENT,
  TableView: LinkAreaLayout.HORIZONTAL,
  TextField: LinkAreaLayout.CLIENT,
  Tabs: LinkAreaLayout.H_AVG,
  Switch: LinkAreaLayout.CLIENT,
  SwitchIOS: LinkAreaLayout.CLIENT,
  Slider: LinkAreaLayout.CLIENT,
  ScopeBar: LinkAreaLayout.H_AVG,
  Spinner: LinkAreaLayout.CLIENT,
  AlarmIcon: LinkAreaLayout.CLIENT,
  AlarmIcon2: LinkAreaLayout.CLIENT,
  'Top ActionBar': LinkAreaLayout.CUSTOM,
  'Contexual ActionBar': LinkAreaLayout.CLIENT,
  'Control PopOver': LinkAreaLayout.H_AVG,
  'StatusBar(IOS)': LinkAreaLayout.CLIENT,
  'StatusBar(Android)': LinkAreaLayout.CLIENT,
  Keyboard: LinkAreaLayout.CLIENT,
  PointyButton: LinkAreaLayout.CLIENT,
  TimePicker: LinkAreaLayout.CLIENT,
  LetterNavigation: LinkAreaLayout.CLIENT,
  'Avatar(Mobile)': LinkAreaLayout.CLIENT,
  QuickContact: LinkAreaLayout.CLIENT,
  QRCode: LinkAreaLayout.CLIENT,
  Calendar: LinkAreaLayout.CLIENT,
  Webcam: LinkAreaLayout.CLIENT,
  AvatarEx: LinkAreaLayout.CLIENT,
  VolumeSlider: LinkAreaLayout.CLIENT,
  Media_Control: LinkAreaLayout.CLIENT,
  VideoPlayer: LinkAreaLayout.CLIENT,
  BarChart: LinkAreaLayout.CLIENT,
  BarChartEx: LinkAreaLayout.CLIENT,
  ColumnChart: LinkAreaLayout.CLIENT,
  ColumnChartEx: LinkAreaLayout.CLIENT,
  LineChart: LinkAreaLayout.CLIENT,
  LineChartEx: LinkAreaLayout.CLIENT,
  PieChart: LinkAreaLayout.CLIENT,

  Map: LinkAreaLayout.CLIENT,
  CoverFlow: LinkAreaLayout.CLIENT,
  EditToolbar: LinkAreaLayout.CLIENT,
  FormattingToolbar: LinkAreaLayout.CLIENT,
  StickyNote: LinkAreaLayout.CLIENT,
  Arrow: LinkAreaLayout.CLIENT,
  CallOut: LinkAreaLayout.CLIENT,
  HCurly: LinkAreaLayout.CLIENT,
  VCurly: LinkAreaLayout.CLIENT,
  RedX: LinkAreaLayout.CLIENT,
  Graffiti: LinkAreaLayout.CLIENT,
  ScratchOut: LinkAreaLayout.CLIENT,
  Panel: LinkAreaLayout.CLIENT,
  BigTitle: LinkAreaLayout.CLIENT,
  Subtitle: LinkAreaLayout.CLIENT,
  Canvas: LinkAreaLayout.CLIENT,
  ScrollView: LinkAreaLayout.CLIENT,
  ContentPanel: LinkAreaLayout.CLIENT,
  ImageCarousel: LinkAreaLayout.CLIENT
};

/*链接坐标等遍历判断*/
function updateLinkCoords(comp) {
  var rect;

  if (!comp.links || !comp.links.link) {
    return;
  }
  if (LinkFitMode[comp.controlTypeID] === LinkAreaLayout.HORIZONTAL) { // 链接宽度始终与组件的宽度相等
    _.each(comp.links.link, function (link) {
      rect = util.Rect.strToRect(link.area.coords);
      util.Rect.setSize(rect, comp.currentW || comp.w);
      link.area.coords = rect;
    });
    if (comp.interactiveData) {
      _.each(comp.interactiveData.entry, function (entry) {
        rect = util.Rect.strToRect(entry.area.coords);
        util.Rect.setSize(rect, comp.currentW || comp.w);
        entry.area.coords = rect;
      });
    }
  } else if (LinkFitMode[comp.controlTypeID] === LinkAreaLayout.VERTICAL) {//链接高度始终与组件高度相等
    _.each(comp.links.link, function (link) {
      rect = util.Rect.strToRect(link.area.coords);
      util.Rect.setSize(rect, rect.width, comp.currentH || comp.h);
      link.area.coords = rect;
    });
    if (comp.interactiveData) {
      _.each(comp.interactiveData.entry, function (entry) {
        rect = util.Rect.strToRect(entry.area.coords);
        util.Rect.setSize(rect, rect.width, comp.currentH || comp.h);
        entry.area.coords = rect;
      });
    }
  } else if (LinkFitMode[comp.controlTypeID] === LinkAreaLayout.CLIENT) {//链接与组件尺寸相同
    _.each(comp.links.link, function (link) {
      rect = util.Rect.strToRect(link.area.coords);
      util.Rect.setSize(rect, comp.currentW || comp.w, comp.currentH || comp.h);
      link.area.coords = rect;
    });
    if (comp.interactiveData) {
      _.each(comp.interactiveData.entry, function (entry) {
        rect = util.Rect.strToRect(entry.area.coords);
        util.Rect.setSize(rect, comp.currentW || comp.w, comp.currentH || comp.h);
        entry.area.coords = rect;
      })
    }
  } else if (LinkFitMode[comp.controlTypeID] === LinkAreaLayout.H_AVG) {//链接水平等分组件
    var left = 0;
    var count = comp.links.link.length || 1;
    var itemW = (comp.currentW || comp.w) / count;
    _.each(comp.links.link, function (link) {
      rect = util.Rect.strToRect(link.area.coords);
      util.Rect.setLocation(rect, left);
      util.Rect.setSize(rect, itemW, comp.currentH || comp.h);
      link.area.coords = rect;
      left += itemW;

    });
    if (comp.interactiveData) {
      left = 0;
      _.each(comp.interactiveData.entry, function (entry) {
        rect = util.Rect.strToRect(entry.area.coords);
        util.Rect.setLocation(rect, left);
        util.Rect.setSize(rect, itemW, comp.currentH || comp.h);
        entry.area.coords = rect;
        left += itemW;
      })
    }
  } else if (LinkFitMode[comp.controlTypeID] === LinkAreaLayout.CUSTOM) {
    var link = comp.links.link[0];
    var entry;
    rect = util.Rect.strToRect(link.area.coords);
    util.Rect.setLocation(rect, rect.left, ((comp.currentH || comp.h) - rect.height) / 2);
    link.area.coords = rect;
    if (comp.interactiveData) {
      entry = comp.interactiveData.entry[0];
      entry.area.coords = rect;
    }

    link = comp.links.link[1];
    rect = util.Rect.strToRect(link.area.coords);
    util.Rect.setLocation(rect, (comp.currentW || comp.w) - 15 - rect.width, ((comp.currentH || comp.h) - rect.height) / 2);
    link.area.coords = rect;
    if (comp.interactiveData) {
      entry = comp.interactiveData.entry[1];
      entry.area.coords = rect;
    }
  } else {
    _.each(comp.links.link, function (link) {
      rect = util.Rect.strToRect(link.area.coords);
      link.area.coords = rect;
    });
    if (comp.interactiveData) {
      _.each(comp.interactiveData.entry, function (entry) {
        rect = util.Rect.strToRect(entry.area.coords);
        entry.area.coords = rect;
      })
    }
  }
}

function isCompositeCom(typeID){
  return typeID === 'IconButton2' || typeID === 'IconLabel2' || typeID === 'AlarmIcon2';
}

function isIgnoreCom(typeID){
  return typeID ==='Border' || typeID === 'ScrollViewPort' || typeID === 'ScrollViewContentPanel';
}

function replaceComTypeID(comp){
  var typeID = comp.controlTypeID;
  if(typeID === 'Circle'){
    comp.controlTypeID = 'Shape';
  }
}

function makeComp(comp, comEvents) {
  try {
    var c = comp;
    var Comp;

    replaceComTypeID(c);

    updateLinkCoords(c);

    replaceComTypeID(c);

    if (isIgnoreCom(c.controlTypeID)) {
      return undefined;
    }
    Comp = Components[c.controlTypeID];

    if (Comp) {
      Comp.key = c.controlID; // react
      c.events = comEvents;
      if (c.controlTypeID === 'CompositeComboBox' && c.hasOwnProperty('baseHeight')) {
        c.h = c.baseHeight;
      }else if (isCompositeCom(c.controlTypeID)){
        c.textColor = c.items[2].textColor;
      }
      //包含有子组件的情况
      if (c.items) {
        //所有非可视化组件
        if (isInvisualInteractiveCom(c.controlTypeID)) {
          //其它弹出组件，它们的Content是一个组类型的组件
          //这里直接忽略掉背景这一层组件
          if (c.items[1].items) {
            return (
              <Comp {...c}>
                {
                  c.items[1].items.map(function (_comp) {
                    return makeComp(_comp, comEvents)
                  })
                }
              </Comp>
            );
          } else {
            return (<Comp {...c}>
              {
                makeComp(c.items[1], comEvents)
              }
            </Comp>);
          }
        } else if (c.controlTypeID === 'ContentPanel') {
          return (<Comp key={c.controlID} {...c}>
            {
              c.items.map(function (_comp, index) {
                _comp.h = c.h;
                _comp.w = c.w;
                _comp.y = 0;
                _comp.x = 0;
                _comp.contentLayout = c.contentLayout;
                _comp.canHoriScroll = c.canHoriScroll;
                _comp.canVertScroll = c.canVertScroll;
                _comp.showScrollBars = c.showScrollBars;
                return (<div key={index} ref={index} style={{
                  width: c.w,
                  height: c.h,
                  left: 0,
                  top: 0,
                  position: 'absolute'
                }}>
                  {
                    makeComp(_comp, comEvents)
                  }
                </div>);
              })
            }
          </Comp>);
        } else {
          if (c.controlTypeID === 'ImageCarousel') {
            delete c.links;
            delete c.interactiveData;
          }
          return (

            <Component key={'_' + c.controlID} {...c}>
              <Comp {...c}>
                {
                  c.items.map(function (_comp, index) {
                    //图片轮播组件把组件本身的填充模式传递到内层图片组件上
                    //这里之所以要把内层图片解析成组件，是考虑到以后图片轮播中可以添加其它组件，可以设置交互等
                    if (c.controlTypeID === 'ImageCarousel') {
                      _comp.fitMode = c.fitMode;
                      _comp.color = c.color;
                      _comp.w = c.w;
                      _comp.h = c.h;
                      _comp.currentW = c.currentW;
                      _comp.currentH = c.currentH;
                    }

                    //滚动区中内容层不再创建为一个组件
                    if (_comp.controlTypeID === 'ScrollViewContentPanel' || _comp.controlTypeID == 'ScrollViewPort') {
                      if (_comp.items) {
                        if (c.controlTypeID === 'ScrollArea') {
                          c.viewPortSize = adjustContentPanelChildPosition(_comp.items, c.contentLayout);
                        }
                        return _comp.items.map(function (itm) {

                          return makeComp(itm, comEvents);
                        });
                      }
                    }

                    //对所有组件中如果包含的有边框层的话，都进行忽略
                    if (_comp.controlTypeID !== 'Border') {
                      return makeComp(_comp, comEvents)
                    }
                  })
                }
              </Comp>
            </Component>
          );
        }
      }
      //普通组件，不包含子组件
      return (
        <Component key={'_' + c.controlID} {...c}>
          <Comp {...c}/>
        </Component>
      );
    }
    console.warn('Cannot find component for ' + c.controlTypeID);
    return (
      <div style={{
        color: 'red'
      }}>Component {c.controlTypeID} is missing.</div>
    );
  }
  catch (e) {
    logHelper.error(e);
    return (
      <div style={{
        color: 'red'
      }}>Error in render {comp.controlTypeID}.</div>
    )
  }
}

function adjustContentPanelChildPosition(items, layout) {
  var x;
  var y;
  var w = 0;
  var h = 0;
  var i;
  var item;
  var l;
  if (layout === 'clRelatively') {
    if (items && items.length) {
      x = items[0].x;
      y = items[0].y;
      i = 1;
      l = items.length;
      if (l > i) {
        for (i; i < l; i++) {
          item = items[i];
          x = Math.min(x, item.x);
          y = Math.min(y, item.y);
        }
      }
      i = 0;
      x -= 1;//补偿左上角1像素的边界
      y -= 1;
      for (i; i < l; i++) {
        item = items[i];
        item.x -= x;
        item.y -= y;
        w = Math.max(w, item.x + item.w);
        h = Math.max(h, item.y + item.h);
      }
    }
  } else {
    l = items ? items.length : 0;
    for (i = 0; i < l; i++) {
      item = items[i];
      w = Math.max(w, item.x + item.w);
      h = Math.max(h, item.y + item.h);
    }
  }
  return {
    w: w + 2,//补偿两个像素的边界
    h: h + 2
  }
}

exports.makeComp = makeComp;



// WEBPACK FOOTER //
// ./src/views/Components/compHelper.js